import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceBreakline, TransformTelNum, FormatTimePipe } from './pipe-function';



@NgModule({
  declarations: [ReplaceBreakline, FormatTimePipe, TransformTelNum],
  imports: [
    CommonModule
  ],
  exports:[ReplaceBreakline, FormatTimePipe, TransformTelNum]
})
export class PipeSofyModule { }
